/**
 * Styled Components - Created by gustavomedina on 12/04/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import Popover from 'antd/lib/popover'
import { GREEN_TRANSPARENT, GREEN, BLUE_SKY, GRAY_DARK, WHITE } from '../../theme/colors'

interface StyleProps {
  withBorder?: boolean
}

type StyledProps = {
  backgroundColor?: string
  showTooltips?: boolean
  isHovered?: boolean
  archived?: boolean
  withBorder?: boolean
  withMargin?: boolean
  selected?: boolean
  reverse?: boolean
  secondary?: boolean
}

export const Footer = styled.div`
  padding: 4px;
  position: relative;
  @media (max-width: 698px) {
    margin: 0px 6px;
    padding-bottom: 0;
    flex: 1;
  }
`

export const Type = styled.div`
  color: #5f6062;
  font-size: 14px;
  font-weight: bold;
  font-family: Avenir;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 220px;
  display: flex;
  margin-top: 4px;
  justify-content: space-between;
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const GendersDiv = styled.div`
  display: inline-flex;
  margin-right: 14px;
  position: absolute;
  top: ${({ secondary }: StyledProps) => secondary ? '-36px' : '-62px'};
  right: 0;
  align-items: flex-end;
  box-shadow: 0px 0px 3px #f1f4f5;
  height: 30px;
  @media (max-width: 698px) {
    display: none;
    height: 0px;
  }
`

export const GendersMobileDiv = styled.div`
  display: none;
  height: 0px;
  @media (max-width: 698px) {
    display: inline-flex;
    align-items: center;
    filter: drop-shadow(0px 0px 3px #f1f4f5);
    height: 20px;
  }
`

export const MenIcon = styled(Icon)`
  margin-left: 8px;
  color: ${BLUE_SKY};
  margin-bottom: 4px;
  @media (max-width: 698px) {
    margin-left: unset;
  }
`

export const YouthLabel = styled.div`
  font-size: 10px;
  color: #549c8c;
  margin-left: 2px;
  display: inline-block;
  vertical-align: bottom;
  max-width: 54px;
  text-align: right;
  line-height: 15px;
  @media (max-width: 698px) {
    max-width: 100px;
  }
`

export const WomenIcon = styled(Icon)<{$marginLeftEnabled?: boolean}>`
  margin-left: 8px;
  color: deeppink;
  margin-bottom: 4px;
  @media (max-width: 698px) {
    margin-left: ${props => props.$marginLeftEnabled ? '8px' : 'unset'}
  }
`

export const Description = styled.div`
  user-select: all;
  color: #8c8c8c;
  font-size: 12px;
  line-height: 16px;
  padding: 2px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 220px;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const Bottom = styled.div`
  user-select: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
`

export const Label = styled.div<{$rightAlignment?: boolean}>`
  user-select: none;
  color: #5f6062;
  font-size: 11.5px;
  line-height: 16px;
  text-align: right;
  width: 82px;
`

export const PriceLabel = styled.div`
  display: flex;
  user-select: none;
  color: #2a2a2a;
  padding: 2px 0px;
  font-size: 18px;
  line-height: 16px;
  text-transform: uppercase;
  text-align: right;
  margin-left: 5px;
  font-weight: bold;
  font-family: Avenir;
`

export const Price = styled.div`
  user-select: none;
  color: #5f6062;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

export const Delete = styled.div`
  color: #e61737;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
`

export const Private = styled.span`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 16px;
`
export const BottomPrices = styled.div`
  display: flex;
  flex-direction: ${({ reverse }: StyledProps) => reverse ? 'column-reverse' : 'column'};
  align-items: flex-end;
  justify-content: space-between;
  margin-top: -4px;
  @media (max-width: 698px) {
    margin-top: -14px;
  }
`

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  ${({ secondary }: StyledProps) => secondary ? `
    flex-flow: row;
    .priceLabel {
      font-size: 11px;
      color: #999999;
    }
    .priceAmount {
      padding: 0;
      color: #999999;
      font-size: 11px;
      font-weight: normal;
      text-decoration: line-through;
    }
    .no-dash {
      text-decoration: unset;
    }
  ` : ''}
  @media(max-width: 698px) {
    &:last-child {
      flex: 1;
      align-items: flex-end;
      .priceLabel {
        text-align: right;
      }
    }
  }
`

export const ContainerCurrentPrice = styled.div<{$marginTop?: boolean}>`
  ${props => props.$marginTop ? `margin-top: 10px; margin-bottom: 10px` : ''}
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 2px;
`

export const LabelCurrentPrice = styled.div`
  font-size: 14px;
`

export const ValuesContainerCurrentPrice = styled.div`
  display: flex;
  gap: 4px;
  font-size: 22px;
  font-weight: 600;
  align-items: baseline;
`

export const PercLabel = styled.div`
  font-size: 11.5px;
  font-weight: 500;
  color: #ff5757;
  align-self: flex-end;
  line-height: 1.05;
  margin-right: 4px;
`

export const AmountCurrentPrice = styled.div`
  display: flex;
  gap: 8px;
`

export const SignCurrentPrice = styled.span``

export const ContainerRegularPrice = styled.div`
  display: flex;
  gap: 6px;
  color: #c8c8c8;
  font-size: 10px;
`

export const LineThroughRegularPrice = styled.div`
  text-decoration: line-through;
`

export const ProgressWrapper = styled.div`
  width: 100%;
  position: relative;
  margin-top: 10px;
  .ant-progress-bg {
    height: 25px !important;
    background-color: ${GREEN_TRANSPARENT};
    border-radius: 3px !important;
  }

  .ant-progress-outer {
    display: block;
    padding-right: 0;
  }

  .ant-progress-inner {
    border-radius: 3px !important;
  }

  .ant-progress-text {
    overflow: hidden;
    color: transparent;
    display: none;
  }
  margin-bottom: 10px;
  @media (max-width: 698px) {
    margin-bottom: 6px;
  }
`

export const ProgressText = styled.div`
  font-size: 13px;
  font-weight: 600;
  position: absolute;
  z-index: 1;
  margin: auto;
  left: 0;
  right: 0;
  top: 6px;
  bottom: 0;
  text-align: center !important;
`

export const SaveText = styled.div`
  bottom: 0px;
  font-size: 12px;
  text-align: center;
  color: ${GREEN};
  &.mobile {
    display: none;
    @media (max-width: 698px) {
      display: block;
    }
  }
  &.desktop {
    display: block;
    @media (max-width: 698px) {
      display: none;
    }
  }
`

export const RetailColors = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 6px;
  @media (max-width: 767px) {
    align-items: start;
    row-gap: 3px;
}`

export const ImgIcon = styled.img`
  height: 15px;
  margin-right: 5px;
  width: 15px;
  border-radius: 50%;
  ${({ withBorder }: StyleProps) => (withBorder ? 'border: 1px solid' : '')};
`

export const ColorsList = styled.div`
  flex-wrap: wrap;
  margin-top: 4px;
  margin-bottom: 2px;
`

export const CoreLabel = styled.div`
  position: absolute;
  bottom: calc(100% + 196px);
  left: 8px;
  font-size: 10px;
  color: white;
  font-weight: normal;
  border: 1px solid white;
  border-radius: 4px;
  padding: 0 7px;
  background: #00000030;
  @media (max-width: 698px) {
    bottom: calc(100% + 202px);
    left: 10px;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const StyledTooltip = styled(Popover)`
  .ant-popover-inner-content {
    padding-top: 1px;
  }
`

export const TextBody = styled.div``

export const TooltipBody = styled.div`
  max-width: 247px;
  width: 100%;
  text-align: center;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const ColorOption = styled.div`
  width: fit-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 18px;
  width: 18px;
  margin-right: 10px;
  transition: all .25s;
  @media (max-width: 767px) {
    margin-right: 6px;
    height: 16px;
  }
`

interface DivProps {
  secondary?: boolean
}

export const ColorName = styled.div`
  z-index: 2;
  color: #b0b0b0;
  font-size: 10px;
  mix-blend-mode: difference;
  white-space: nowrap;
  ${({ secondary }: DivProps) => (secondary ? `
    color: ${WHITE};
    mix-blend-mode: unset;
  ` : '')};
   @media (max-width: 767px) {
    font-size: 8px;
   }
`

export const ProductAvailableColor = styled.img`
  position: absolute;
  z-index: 1;
  object-fit: cover;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 25px;
  transition: all .25s;
  border: ${({ selected, withBorder }: StyledProps) =>
    selected
      ? `2px solid #ff99a9`
      : (withBorder ? `1px solid ${GRAY_DARK}` : 'none')};
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FooterThumbnailTeamStore/styledComponents.tsx